import React from 'react';
import Textfield from '@atlaskit/textfield';
import { DisplayMode } from '../../RenderForm';
import { FieldDisabledWrapper, ViewWrapper } from '../common/questionWrappers';
export var ViewNumber = function ViewNumber(_ref) {
  var id = _ref.id,
    value = _ref.value,
    displayMode = _ref.displayMode;
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(FieldDisabledWrapper, null, /*#__PURE__*/React.createElement(Textfield, {
      id: id,
      value: value,
      isReadOnly: true,
      width: "small",
      label: "number",
      "aria-label": "number field",
      title: "number",
      placeholder: "",
      role: "presentation"
    }));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, value);
};